function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable */
// @ts-nocheck
import Location from 'jsts/org/locationtech/jts/geom/Location';
import TreeSet from 'jsts/java/util/TreeSet';
import LineString from 'jsts/org/locationtech/jts/geom/LineString';
import Geometry from 'jsts/org/locationtech/jts/geom/Geometry';
import ConnectedInteriorTester from 'jsts/org/locationtech/jts/operation/valid/ConnectedInteriorTester';
import Coordinate from 'jsts/org/locationtech/jts/geom/Coordinate';
import Point from 'jsts/org/locationtech/jts/geom/Point';
import Polygon from 'jsts/org/locationtech/jts/geom/Polygon';
import MultiPoint from 'jsts/org/locationtech/jts/geom/MultiPoint';
import PointLocation from 'jsts/org/locationtech/jts/algorithm/PointLocation';
import LinearRing from 'jsts/org/locationtech/jts/geom/LinearRing';
import Double from 'jsts/java/lang/Double';
import GeometryGraph from 'jsts/org/locationtech/jts/geomgraph/GeometryGraph';
import MultiPolygon from 'jsts/org/locationtech/jts/geom/MultiPolygon';
import ConsistentAreaTester from 'jsts/org/locationtech/jts/operation/valid/ConsistentAreaTester';
import GeometryCollection from 'jsts/org/locationtech/jts/geom/GeometryCollection';
import UnsupportedOperationException from 'jsts/java/lang/UnsupportedOperationException';
import IndexedNestedRingTester from 'jsts/org/locationtech/jts/operation/valid/IndexedNestedRingTester';
import RobustLineIntersector from 'jsts/org/locationtech/jts/algorithm/RobustLineIntersector';
import TopologyValidationError from 'jsts/org/locationtech/jts/operation/valid/TopologyValidationError';
import IndexedPointInAreaLocator from 'jsts/org/locationtech/jts/algorithm/locate/IndexedPointInAreaLocator';
import Assert from 'jsts/org/locationtech/jts/util/Assert';
/*
    File taken from JSTS library and modified to allow multiple validation errors.
    See https://github.com/bjornharrtell/jsts/blob/d3d62353eb32a5dd086e63b373c9831646501a3a/src/org/locationtech/jts/operation/valid/IsValidOp.js.
*/

export default class IsValidOp {
  constructor() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _defineProperty(this, "_validErr", void 0);

    IsValidOp.constructor_.apply(this, arguments);
  }

  static constructor_() {
    this._parentGeometry = null;
    this._isSelfTouchingRingFormingHoleValid = false;
    this._validErr = new Array(0);
    var parentGeometry = arguments[0];
    this._parentGeometry = parentGeometry;
  }

  static findPtNotNode(testCoords, searchRing, graph) {
    var searchEdge = graph.findEdge(searchRing);
    var eiList = searchEdge.getEdgeIntersectionList();

    for (var i = 0; i < testCoords.length; i++) {
      var pt = testCoords[i];
      if (!eiList.isIntersection(pt)) return pt;
    }

    return null;
  }

  static isValid() {
    if (arguments[0] instanceof Geometry) {
      var geom = arguments[0];
      var isValidOp = new IsValidOp(geom);
      return isValidOp.isValid();
    } else if (arguments[0] instanceof Coordinate) {
      var coord = arguments[0];
      if (Double.isNaN(coord.x)) return false;
      if (Double.isInfinite(coord.x)) return false;
      if (Double.isNaN(coord.y)) return false;
      if (Double.isInfinite(coord.y)) return false;
      return true;
    }
  }

  checkInvalidCoordinates() {
    if (arguments[0] instanceof Array) {
      var coords = arguments[0];

      for (var i = 0; i < coords.length; i++) {
        if (!IsValidOp.isValid(coords[i])) {
          this._validErr.push(new TopologyValidationError(TopologyValidationError.INVALID_COORDINATE, coords[i]));

          return null;
        }
      }
    } else if (arguments[0] instanceof Polygon) {
      var poly = arguments[0];
      this.checkInvalidCoordinates(poly.getExteriorRing().getCoordinates());
      if (this._validErr.some(error => error.getErrorType() === TopologyValidationError.INVALID_COORDINATE)) return null;

      for (var _i = 0; _i < poly.getNumInteriorRing(); _i++) {
        this.checkInvalidCoordinates(poly.getInteriorRingN(_i).getCoordinates());
        if (this._validErr.some(error => error.getErrorType() === TopologyValidationError.INVALID_COORDINATE)) return null;
      }
    }
  }

  checkHolesNotNested(p, graph) {
    if (p.getNumInteriorRing() <= 0) return null;
    var nestedTester = new IndexedNestedRingTester(graph);

    for (var i = 0; i < p.getNumInteriorRing(); i++) {
      var innerHole = p.getInteriorRingN(i);
      if (innerHole.isEmpty()) continue;
      nestedTester.add(innerHole);
    }

    var isNonNested = nestedTester.isNonNested();
    if (!isNonNested) this._validErr.push(new TopologyValidationError(TopologyValidationError.NESTED_HOLES, nestedTester.getNestedPoint()));
  }

  checkConsistentArea(graph) {
    var cat = new ConsistentAreaTester(graph);
    var isValidArea = cat.isNodeConsistentArea();

    if (!isValidArea) {
      this._validErr.push(new TopologyValidationError(TopologyValidationError.SELF_INTERSECTION, cat.getInvalidPoint()));
    }

    if (cat.hasDuplicateRings()) this._validErr.push(new TopologyValidationError(TopologyValidationError.DUPLICATE_RINGS, cat.getInvalidPoint()));
  }

  isValid() {
    this.checkValid(this._parentGeometry);
    return this._validErr.length === 0;
  }

  checkShellInsideHole(shell, hole, graph) {
    var shellPts = shell.getCoordinates();
    var holePts = hole.getCoordinates();
    var shellPt = IsValidOp.findPtNotNode(shellPts, hole, graph);

    if (shellPt !== null) {
      var insideHole = PointLocation.isInRing(shellPt, holePts);
      if (!insideHole) return shellPt;
    }

    var holePt = IsValidOp.findPtNotNode(holePts, shell, graph);

    if (holePt !== null) {
      var insideShell = PointLocation.isInRing(holePt, shellPts);
      if (insideShell) return holePt;
      return null;
    }

    Assert.shouldNeverReachHere('points in shell and hole appear to be equal');
    return null;
  }

  checkNoSelfIntersectingRings(graph) {
    for (var i = graph.getEdgeIterator(); i.hasNext();) {
      var e = i.next();
      this.checkNoSelfIntersectingRing(e.getEdgeIntersectionList());
      if (this._validErr.some(error => [TopologyValidationError.RING_SELF_INTERSECTION, TopologyValidationError.SELF_INTERSECTION].includes(error.getErrorType()))) return null;
    }
  }

  checkConnectedInteriors(graph) {
    var cit = new ConnectedInteriorTester(graph);
    if (!cit.isInteriorsConnected()) this._validErr.push(new TopologyValidationError(TopologyValidationError.DISCONNECTED_INTERIOR, cit.getCoordinate()));
  }

  checkNoSelfIntersectingRing(eiList) {
    var nodeSet = new TreeSet();
    var isFirst = true;

    for (var i = eiList.iterator(); i.hasNext();) {
      var ei = i.next();

      if (isFirst) {
        isFirst = false;
        continue;
      }

      if (nodeSet.contains(ei.coord)) {
        if (!this._validErr.some(error => error.getErrorType() === TopologyValidationError.SELF_INTERSECTION)) {
          this._validErr.push(new TopologyValidationError(TopologyValidationError.RING_SELF_INTERSECTION, ei.coord));
        }

        return null;
      } else {
        nodeSet.add(ei.coord);
      }
    }
  }

  checkHolesInShell(p, graph) {
    if (p.getNumInteriorRing() <= 0) return null;
    var shell = p.getExteriorRing();
    var isShellEmpty = shell.isEmpty();
    var pir = new IndexedPointInAreaLocator(shell);

    for (var i = 0; i < p.getNumInteriorRing(); i++) {
      var hole = p.getInteriorRingN(i);
      var holePt = null;
      if (hole.isEmpty()) continue;
      holePt = IsValidOp.findPtNotNode(hole.getCoordinates(), shell, graph);
      if (holePt === null) return null;
      var outside = isShellEmpty || Location.EXTERIOR === pir.locate(holePt);

      if (outside) {
        this._validErr.push(new TopologyValidationError(TopologyValidationError.HOLE_OUTSIDE_SHELL, holePt));

        return null;
      }
    }
  }

  checkTooFewPoints(graph) {
    if (graph.hasTooFewPoints()) {
      this._validErr.push(new TopologyValidationError(TopologyValidationError.TOO_FEW_POINTS, graph.getInvalidPoint()));

      return null;
    }
  }

  getValidationError() {
    this.checkValid(this._parentGeometry);
    return this._validErr;
  }

  checkValid() {
    if (arguments[0] instanceof Point) {
      var g = arguments[0];
      this.checkInvalidCoordinates(g.getCoordinates());
    } else if (arguments[0] instanceof MultiPoint) {
      var _g = arguments[0];
      this.checkInvalidCoordinates(_g.getCoordinates());
    } else if (arguments[0] instanceof LinearRing) {
      var _g2 = arguments[0];
      this.checkInvalidCoordinates(_g2.getCoordinates());
      this.checkClosedRing(_g2);
      var graph = new GeometryGraph(0, _g2);
      this.checkTooFewPoints(graph);
      var li = new RobustLineIntersector();
      graph.computeSelfNodes(li, true, true);
      this.checkNoSelfIntersectingRings(graph);
    } else if (arguments[0] instanceof LineString) {
      var _g3 = arguments[0];
      this.checkInvalidCoordinates(_g3.getCoordinates());

      var _graph = new GeometryGraph(0, _g3);

      this.checkTooFewPoints(_graph);
    } else if (arguments[0] instanceof Polygon) {
      var _g4 = arguments[0];
      this.checkInvalidCoordinates(_g4);
      this.checkClosedRings(_g4);

      var _graph2 = new GeometryGraph(0, _g4);

      this.checkTooFewPoints(_graph2);
      this.checkConsistentArea(_graph2);

      if (!this._isSelfTouchingRingFormingHoleValid) {
        this.checkNoSelfIntersectingRings(_graph2);
      }

      this.checkHolesInShell(_g4, _graph2);
      this.checkHolesNotNested(_g4, _graph2);
      _graph2 = new GeometryGraph(0, _g4);
      this.checkConnectedInteriors(_graph2);
    } else if (arguments[0] instanceof MultiPolygon) {
      var _g5 = arguments[0];

      for (var i = 0; i < _g5.getNumGeometries(); i++) {
        var p = _g5.getGeometryN(i);

        this.checkInvalidCoordinates(p);
        this.checkClosedRings(p);
      }

      var _graph3 = new GeometryGraph(0, _g5);

      this.checkTooFewPoints(_graph3);
      this.checkConsistentArea(_graph3);

      if (!this._isSelfTouchingRingFormingHoleValid) {
        this.checkNoSelfIntersectingRings(_graph3);
      }

      for (var _i2 = 0; _i2 < _g5.getNumGeometries(); _i2++) {
        var _p = _g5.getGeometryN(_i2);

        this.checkHolesInShell(_p, _graph3);
      }

      for (var _i3 = 0; _i3 < _g5.getNumGeometries(); _i3++) {
        var _p2 = _g5.getGeometryN(_i3);

        this.checkHolesNotNested(_p2, _graph3);
      }

      this.checkShellsNotNested(_g5, _graph3);
      _graph3 = new GeometryGraph(0, _g5);
      this.checkConnectedInteriors(_graph3);
    } else if (arguments[0] instanceof GeometryCollection) {
      var gc = arguments[0];

      for (var _i4 = 0; _i4 < gc.getNumGeometries(); _i4++) {
        var _g6 = gc.getGeometryN(_i4);

        this.checkValid(_g6);
      }
    } else if (arguments[0] instanceof Geometry) {
      var _g7 = arguments[0];
      if (_g7.isEmpty()) return null;
      if (_g7 instanceof Point) this.checkValid(_g7);else if (_g7 instanceof MultiPoint) this.checkValid(_g7);else if (_g7 instanceof LinearRing) this.checkValid(_g7);else if (_g7 instanceof LineString) this.checkValid(_g7);else if (_g7 instanceof Polygon) this.checkValid(_g7);else if (_g7 instanceof MultiPolygon) this.checkValid(_g7);else if (_g7 instanceof GeometryCollection) this.checkValid(_g7);else throw new UnsupportedOperationException(_g7.getGeometryType());
    }
  }

  setSelfTouchingRingFormingHoleValid(isValid) {
    this._isSelfTouchingRingFormingHoleValid = isValid;
  }

  checkShellNotNested(shell, p, graph) {
    var shellPts = shell.getCoordinates();
    var polyShell = p.getExteriorRing();
    if (polyShell.isEmpty()) return null;
    var polyPts = polyShell.getCoordinates();
    var shellPt = IsValidOp.findPtNotNode(shellPts, polyShell, graph);
    if (shellPt === null) return null;
    var insidePolyShell = PointLocation.isInRing(shellPt, polyPts);
    if (!insidePolyShell) return null;

    if (p.getNumInteriorRing() <= 0) {
      this._validErr.push(new TopologyValidationError(TopologyValidationError.NESTED_SHELLS, shellPt));

      return null;
    }

    var badNestedPt = null;

    for (var i = 0; i < p.getNumInteriorRing(); i++) {
      var hole = p.getInteriorRingN(i);
      badNestedPt = this.checkShellInsideHole(shell, hole, graph);
      if (badNestedPt === null) return null;
    }

    this._validErr.push(new TopologyValidationError(TopologyValidationError.NESTED_SHELLS, badNestedPt));
  }

  checkClosedRings(poly) {
    this.checkClosedRing(poly.getExteriorRing());
    if (this._validErr.some(error => error.getErrorType() === TopologyValidationError.RING_NOT_CLOSED)) return null;

    for (var i = 0; i < poly.getNumInteriorRing(); i++) {
      this.checkClosedRing(poly.getInteriorRingN(i));
      if (this._validErr.some(error => error.getErrorType() === TopologyValidationError.RING_NOT_CLOSED)) return null;
    }
  }

  checkClosedRing(ring) {
    if (ring.isEmpty()) return null;

    if (!ring.isClosed()) {
      var pt = null;
      if (ring.getNumPoints() >= 1) pt = ring.getCoordinateN(0);

      this._validErr.push(new TopologyValidationError(TopologyValidationError.RING_NOT_CLOSED, pt));
    }
  }

  checkShellsNotNested(mp, graph) {
    for (var i = 0; i < mp.getNumGeometries(); i++) {
      var p = mp.getGeometryN(i);
      var shell = p.getExteriorRing();

      for (var j = 0; j < mp.getNumGeometries(); j++) {
        if (i === j) continue;
        var p2 = mp.getGeometryN(j);
        this.checkShellNotNested(shell, p2, graph);
        if (this._validErr.some(error => error.getErrorType() === TopologyValidationError.NESTED_SHELLS)) return null;
      }
    }
  }

}